import { createFileRoute } from "@tanstack/react-router";
import { AuthenticationEditor } from "@/features/admin-authentication/AuthenticationEditor";
function Page() { const { session } = Route.useRouteContext(); return <AuthenticationEditor key={session.user.id} actorId={session.user.id} />; }
export const Route = createFileRoute("/_authenticated/_protected/_admin/admin/authentication")({ component: Page });
